// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout__sidebar {
  max-width: 400px;
}

.layout__main-content {
  flex: 1;
  min-width: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/page-layout/PageLayout/PageLayout.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;AACd","sourcesContent":[".layout__sidebar {\n  max-width: 400px;\n}\n\n.layout__main-content {\n  flex: 1;\n  min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
